import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { RootState } from "../../../app/store";
import { ClientContactStateClass } from "./interfaces/ClientContactStateClass";
import fetchAPI from "../../../common/fetchAPI";
import { create } from "domain";


const initialState: ClientContactStateClass = {
    isLoading: false,
    status: "idle",
    isReload: false,
    selectedRecord: {},
    clientContactList: []
}

interface IThunkApi {
    state: {
        clientContact: ClientContactStateClass
    }
}

export const getAccountEmployeeTypeAsync = createAsyncThunk
    <any, void, IThunkApi>
    (
        "EmployeeTypes/v2/getAccountEmployeeType",
        async (arg, thunkApi) => {
            //const response = await fetchAPI("api/EmployeeTypes","GET","",true,"0df3ab0c-4033-4013-8b1e-2f0b64f8cbab");
            const response = await fetchAPI("api/v2/EmployeeTypes", "GET", "", true, "0df3ab0c-4033-4013-8b1e-2f0b64f8cbab");
            const json = response.json();
            return json;
        }

    )

export const getClientContactsByAccountPartyIdAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        "ClientContacts/v2/getClientContactsByAccountPartyId",
        async (arg, thunkApi) => {
            //const response = await fetchAPI("api/EmployeeTypes/" + arg,"GET","",true,"0df3ab0c-4033-4013-8b1e-2f0b64f8cbab");
            const response = await fetchAPI("api/v2/ClientContacts/" + arg, "GET", "", true, "0df3ab0c-4033-4013-8b1e-2f0b64f8cbab");
            const json = response.json();
            return json;
        }
    )
    export const getAccountPartyContactsByAccountPartyIdAndAccountClientContactIdAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        "ClientContacts/v2/getAccountPartyContactsByAccountPartyIdAndAccountClientContactId",
        async (arg, thunkApi) => {
            const { AccountPartyContactId,AccountPartyId, ...argWithoutId } = arg;
            //const response = await fetchAPI("api/EmployeeTypes/" + arg,"GET","",true,"0df3ab0c-4033-4013-8b1e-2f0b64f8cbab");
            const response = await fetchAPI("api/v2/ClientContacts/PartyContactsById/" + AccountPartyContactId + "/" + AccountPartyId, "GET", "", true, "0df3ab0c-4033-4013-8b1e-2f0b64f8cbab");
            const json = response.json();
            return json;
        }
    )
    

export const addAccountClientContactAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        "ClientContacts/v2/addAccountClientContact",
        async (arg, thunkApi) => {
            // const response = await fetchAPI("api/EmployeeTypes/","POST",arg,true,"0df3ab0c-4033-4013-8b1e-2f0b64f8cbab");
            const response = await fetchAPI("api/v2/ClientContacts/", "POST", arg, true, "0df3ab0c-4033-4013-8b1e-2f0b64f8cbab");
            const json = response.json();
            return json;
        }
    )

export const updateAccountClientContactAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        "ClientContacts/v2/updateAccountClientContact",
        async (arg, thunkApi) => {
            const { AccountPartyContactId,AccountExpenseTypeId, ...argWithoutId } = arg;
            //const response = await fetchAPI("api/EmployeeTypes/"+AccountEmployeeTypeId,"POST",arg,true,"0df3ab0c-4033-4013-8b1e-2f0b64f8cbab");
            const response = await fetchAPI("api/v2/ClientContacts/" + AccountPartyContactId, "PUT", argWithoutId, true, "0df3ab0c-4033-4013-8b1e-2f0b64f8cbab");
            const json = response.json();
            return json;
        }
    )

export const deleteAccountClientContactAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        "ClientContacts/v2/deleteAccountClientContact",
        async (arg, thunkApi) => {
            //const response = await fetchAPI("api/EmployeeTypes/" + arg,"Delete","",true,"0df3ab0c-4033-4013-8b1e-2f0b64f8cbab");
            const response = await fetchAPI("api/v2/ClientContacts/" + arg, "Delete", "", true, "0df3ab0c-4033-4013-8b1e-2f0b64f8cbab");
            const json = response.json();
            return json;
        }
    )
export const DeleteSelectedAccountClientContactAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        "ClientContacts/v2/DeleteSelectedAccountClientContact",
        async (arg, thunkApi) => {
            const response = await fetchAPI('api/v2/ClientContacts/DeleteSelected/', 'Delete', arg, true, '0df3ab0c-4033-4013-8b1e-2f0b64f8cbab');
            const json = await response.json();
            return json;

        }
    )

const clientContactSlice = createSlice({
    name: "clientContact",
    initialState,
    reducers: {
        resetSelectedRecordObjectInState: (state) => {
            state.selectedRecord = {}
        },
        checkedState: (state, action) => {
            const currentindex = state.clientContactList.findIndex((item) => item.AccountPartyContactId == action.payload);
            const newArray = [...state.clientContactList];
            newArray[currentindex] = { ...newArray[currentindex], isSelected: 1 };
            state.clientContactList = newArray;
        },
        unCheckedState: (state, action) => {
            const currentindex = state.clientContactList.findIndex((item) => item.AccountPartyContactId == action.payload);
            const newArray = [...state.clientContactList];
            newArray[currentindex] = { ...newArray[currentindex], isSelected: 0 };
            state.clientContactList = newArray;
        },
        checkedAllState: (state) => {
            const newArray = state.clientContactList.map((item) => ({
                ...item,
                isSelected: 1,
            }));
            state.clientContactList = newArray;
            //state.isAllUnChecked = false;
        },
        unCheckedAllState: (state) => {
            const newArray = state.clientContactList.map((item) => ({
                ...item,
                isSelected: 0,
            }));
            state.clientContactList = newArray;
            //state.isAllUnChecked = true;
        },
        checkAllCheckboxIsUncheckedState: (state) => {
            //state.isAllUnChecked = state.LocationList.every((item) => item.isSelected === 0);
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getAccountEmployeeTypeAsync.pending, (state) => {
                state.status = "loading";
                state.isLoading = true;
            })
            .addCase(getAccountEmployeeTypeAsync.fulfilled, (state, { payload }) => {

                // state.status = "idle";
                // //state.employeeTypeList = payload;
                // if (Object.keys(payload.Data).length === 0) {
                //     // Handle the case where payload.Data is empty or an empty object
                //     state.clientContactList = [];
                // } else {
                //     state.clientContactList = payload.Data;
                //     state.clientContactList.map((item: any) => {
                //         item.isSelected = 0
                //     });
                // }
                // state.isReload = false;
                // state.isLoading = false;
                // state.selectedRecord = {};
            })
            .addCase(getAccountEmployeeTypeAsync.rejected, (state) => {
                state.status = "failed";
            })

            .addCase(getClientContactsByAccountPartyIdAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;
            })
            .addCase(getClientContactsByAccountPartyIdAsync.fulfilled, (state, { payload }) => {
                state.status = "idle";
                //state.employeeTypeList = payload;
                console.log('payload.Data:',payload.Data);
                if (Object.keys(payload.Data).length === 0) {
                    // Handle the case where payload.Data is empty or an empty object
                    state.clientContactList = [];
                } else {
                    state.clientContactList = payload.Data;
                    state.clientContactList.map((item: any) => {
                        item.isSelected = 0
                    });
                }
                state.isReload = false;
                state.isLoading = false;
                state.selectedRecord = {};
                
            })
            .addCase(getClientContactsByAccountPartyIdAsync.rejected, (state) => {
                state.status = 'failed';
            })

            .addCase(getAccountPartyContactsByAccountPartyIdAndAccountClientContactIdAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;
            })
            .addCase(getAccountPartyContactsByAccountPartyIdAndAccountClientContactIdAsync.fulfilled, (state, { payload }) => {
                state.status = "idle";
                //state.employeeTypeList = payload;
                
                
                if (Object.keys(payload.Data[0]).length === 0) {
                    // Handle the case where payload.Data is empty or an empty object
                    state.selectedRecord = {};
                } else {
                    console.log('payload.Data:',payload.Data[0]);
                    state.selectedRecord = payload.Data[0];
                }

                state.isReload = false;
                state.isLoading = false;
                
                
            })
            .addCase(getAccountPartyContactsByAccountPartyIdAndAccountClientContactIdAsync.rejected, (state) => {
                state.status = 'failed';
            })

            .addCase(addAccountClientContactAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;
            })
            .addCase(addAccountClientContactAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isReload = true;
                state.isLoading = false;
                console.log('payload add:', payload);

            })
            .addCase(addAccountClientContactAsync.rejected, (state) => {
                state.status = 'failed';
            })

            .addCase(updateAccountClientContactAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;
            })
            .addCase(updateAccountClientContactAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isReload = true;
                state.isLoading = false;
                console.log('payload update:', payload);

            })
            .addCase(updateAccountClientContactAsync.rejected, (state) => {
                state.status = 'failed';
            })

            .addCase(deleteAccountClientContactAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;
            })
            .addCase(deleteAccountClientContactAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isReload = true;
                state.isLoading = false;
            })
            .addCase(deleteAccountClientContactAsync.rejected, (state) => {
                state.status = 'failed';
            })


            .addCase(DeleteSelectedAccountClientContactAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;
            })
            .addCase(DeleteSelectedAccountClientContactAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isReload = true;
                state.isLoading = false;
               // console.log('deleteselected', payload);
            })
            .addCase(DeleteSelectedAccountClientContactAsync.rejected, (state) => {
                state.status = 'failed';
            })

    }
})

export const { resetSelectedRecordObjectInState, checkedState, unCheckedState, checkedAllState, unCheckedAllState, checkAllCheckboxIsUncheckedState } = clientContactSlice.actions
export const EmployeeTypeState = (state: RootState) => state.clientContact
export default clientContactSlice.reducer


